import type { Dispatch, SetStateAction } from 'react'

import { Button, DSButtonType } from 'components'
import { ModalContentLayout } from 'layouts/ModalContentLayout'

import * as S from './styles'

type QuotaSelectModalProps = {
  title: string
  description: string
  open: boolean
  setOpen: Dispatch<SetStateAction<boolean>>
}

const QuotaSelectModal = ({ title, description, open, setOpen }: QuotaSelectModalProps) => {
  const closeAction = () => {
    setOpen(false)
  }

  return (
    <>
      {open && (
        <ModalContentLayout closeAction={closeAction} description={description} title={title}>
          <S.Actions>
            <Button
              color="primary"
              content="Entendi"
              design={DSButtonType.PRIMARY_BUTTON}
              fullWidth={false}
              onClick={closeAction}
            />
          </S.Actions>
        </ModalContentLayout>
      )}
    </>
  )
}

export default QuotaSelectModal
